import React from 'react';
import PropTypes from 'prop-types';

const DragList = ({ id = 'drag-list', children, ...props }) => {
    const onDragOver = (e) => {
        e.preventDefault();
    };

    return (
        <table id={id} {...props}>
            <tbody>
                {children.map((v, k) => (
                    <tr
                        key={k}
                        id={`${id}-row`}
                        style={{
                            boxSizing: 'border-box',
                            backgroundColor:
                                k % 2
                                    ? 'rgba(216,216,216,0.2)'
                                    : 'rgba(255,255,255,0)'
                        }}
                        onDragOver={onDragOver}
                    >
                        {v}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

DragList.defaultProps = {
    id: 'drag-list'
};

DragList.propTypes = {
    id: PropTypes.string,
    children: PropTypes.any
};

export default DragList;
